/**
 * This is the application module's configuration.
 * Do NOT configure routes in this file.
 * @memberOf Application Module
 * @namespace Application Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @param $locationProvider
 * @param $translateProvider
 * @memberOf Application Module.Application Config
 * @ngInject
 */
var config = function($locationProvider, $translateProvider) {

  // Enable HTML5 routing mode instead of using hash-routing.
  $locationProvider.html5Mode(false);

  // sanitize: sanitizes HTML in the translation text using `$sanitize`
  // escape: escapes HTML in the translation
  // sanitizeParameters: sanitizes HTML in the values of the interpolation parameters using `$sanitize`
  // escapeParameters: escapes HTML in the values of the interpolation parameters
  $translateProvider.useSanitizeValueStrategy('escape');

  // Load the translations.
  $translateProvider.useStaticFilesLoader({
      prefix: './assets/translations/',
      suffix: '.json?' + DATETIMESTAMP
    })
    // Register all supported languages.
    .registerAvailableLanguageKeys(
      [
        'cy',
        'de',
        'en-us',
        'en',
        'es-ar',
        'es',
        'fi',
        'fr-ca',
        'fr',
        'it',
        'ja',
        'ko',
        'nl',
        'no',
        'pl',
        'pt-br',
        'pt',
        'ru',
        'sv',
        'tr',
        'vi',
        'zh-cn',
        'zh-tw'
      ], {
        'cy-*': 'cy',
        'de-*': 'de',
        'en-us': 'en-us',
        'en-*': 'en',
        'es-ar': 'es-ar',
        'es-*': 'es',
        'fi-*': 'fi',
        'fr-ca': 'fr-ca',
        'fr-*': 'fr',
        'it-*': 'it',
        'ja-*': 'ja',
        'ko-*': 'ko',
        'nl-*': 'nl',
        'no-*': 'no',
        'pl-*': 'pl',
        'pt-br': 'pt-br',
        'pt-*': 'pt',
        'ru-*': 'ru',
        'sv-*': 'sv',
        'tr-*': 'tr',
        'vi-*': 'vi',
        'zh-cn': 'zh-cn',
        'zh-tw': 'zh-tw'
      })
    // Register the preferred language.
    .preferredLanguage('en')
    // Register the fallback language.
    .fallbackLanguage('en')
    // Determine the language from the browser properties.
    .determinePreferredLanguage();
};

export default config;


// WEBPACK FOOTER //
// ./src/app.config.js